import { Divider, HStack, Text } from '@telescope/cassini-ui';
import React from 'react';

interface OptionsDividerProps {
  text?: string;
}
export const OptionsDivider = ({ text }: OptionsDividerProps) => {
  if (!text) return null;

  return (
    <HStack my={6}>
      <Divider />
      <Text fontSize="sm" whiteSpace="nowrap" color="gray.400">
        {text}
      </Text>
      <Divider />
    </HStack>
  );
};
